import { API, axiosInstance } from "lib";


export const changeBannerStatusData = (data={}) => {
    return axiosInstance
      .post(API.CHANGE_BANNER_STATUS , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
        }
        throw err;
      });
  };